module.exports = __webpack_public_path__ + "static/media/antigua-beaches-40.a5d5d700.jpg";